import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { HolidayService } from '@service/holiday/holiday.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-edit-holiday-modal',
  templateUrl: './edit-holiday-modal.component.html',
  styleUrls: ['./edit-holiday-modal.component.css'],
})
export class EditHolidayModalComponent implements OnInit {
  @Input() isVisible: boolean = false;
  @Input() editData: any;
  @Output() isVisibleChange = new EventEmitter<boolean>();
  @Output() onUpdateHoliday = new EventEmitter<any>();

  eventList: any[] = [];
  formattedDate: string = '';
  selectedEventId: any = null;
  beforeEditEventId: any = null;
  cancelHoliday: boolean = false;
  reasonInput: string = '';

  constructor(private readonly holidayService: HolidayService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['editData'] && this.editData) {
      this.formatIsoDate(this.editData.date);
      this.selectedEventId = this.editData.holiday_event_id;
      this.beforeEditEventId = this.editData.holiday_event_id;
    }
  }

  ngOnInit(): void {
    this.holidayService.getAllHolidayEvent().subscribe((response) => {
      if (response && response.status === 'ok') {
        this.eventList = response.resultset.filter(
          (event) => event.name !== 'Weekend',
        );
      }
    });
  }

  private formatIsoDate(isoString: string): void {
    const d = new Date(isoString);
    if (!isNaN(d.getTime())) {
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();

      this.formattedDate = `${day}/${month}/${year}`;
    } else {
      this.formattedDate = isoString;
    }
  }

  onUpdate(): void {
    if (this.cancelHoliday && !this.reasonInput.trim()) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Please provide a reason for canceling the holiday.',
      });
      return;
    }

    const payload = {
      holiday_event_id: this.selectedEventId,
      is_canceled: this.cancelHoliday,
      cancelation_reason: this.cancelHoliday ? this.reasonInput : null,
    };

    this.holidayService
      .updateHoliday(
        this.editData.holiday_year,
        this.editData.holiday_event_id,
        this.editData.id,
        payload,
      )
      .subscribe((result) => {
        if (result && result.status === 'ok') {
          this.onUpdateHoliday.emit();
          this.closeModal();
        }
      });
  }

  closeModal(): void {
    this.resetForm();
    this.isVisible = false;
    this.isVisibleChange.emit(false);
  }
  resetForm(): void {
    this.cancelHoliday = false;
    this.reasonInput = '';
    this.selectedEventId = this.editData?.holiday_event_id ?? null;
  }
}
